import { Injectable } from '@angular/core';
import { FiltersOutput } from '../models/filter-objects';
import { BiPivotSettingsDto } from '../pages/settings/settings.service';
import { OverviewFiltersOutput } from '../pages/stock/stock.service';

@Injectable({
    providedIn: "root",
})

export class ShareDataService {

    filterOptions: FiltersOutput;
    filterOptionOverview: OverviewFiltersOutput;
    periodType: string = null;
    ChartSettings: string = "";
    pivotSettings: BiPivotSettingsDto;
    capacityOverviewSelectedColumn: string;
    mapboxMapStyles: MapBoxMapStyle[];
    dataGridState: string;
    currentLocalizationLanguage: string = 'en';

    constructor() {
        this.mapboxMapStyles = [
            {id: "light", value: "mapbox://styles/mapbox/light-v10"},
            {id: "streets", value: "mapbox://styles/mapbox/streets-v11"},
            {id: "outdoors", value: "mapbox://styles/mapbox/outdoors-v11"},
            {id: "dark", value: "mapbox://styles/mapbox/dark-v10"},
            {id: "sattelite", value: "mapbox://styles/mapbox/satellite-v9"},
            {id: "sattelite-streets", value: "mapbox://styles/mapbox/satellite-streets-v11"},
            {id: "navigation-day", value: "mapbox://styles/mapbox/navigation-day-v1"},
            {id: "navigation-night", value: "mapbox://styles/mapbox/navigation-night-v1"}
        ];
    }

    public CleanData() {
        this.filterOptions = null;
        this.filterOptionOverview = null;
        this.periodType = null;
        this.ChartSettings = "";
        this.capacityOverviewSelectedColumn = "";
        this.dataGridState = "";
        this.currentLocalizationLanguage = 'en';
    }

}


export class MapBoxMapStyle{
    id: string;
    value: string;
}
